import api from "../../api";
import CryptoAES from "../../plugins/crypto-aes";
import { UserVaccountAider } from "./user-vaccounts.aider";
import { initUserVaccount } from "./user-vaccounts.inits";

/** @type {import("vuex").Module<{ value: import('./user-vaccounts.inits').UserVaccount | null }>} */
export const vaccount = {
    namespaced: true,
    state: {
        value: initUserVaccount(),
    },
    mutations: {
        setValue(state, { vaccount = null } = {}) {
            state.value = initUserVaccount(vaccount);
        },
    },
    actions: {
        async get({ commit }) {
            let { vaccount } = await api.v1.me.vaccount.get();
            commit("setValue", { vaccount });
        },

        async post({ commit }) {
            return new Promise(async (res, rej) => {
                const resolve = (...params) => {
                    script.remove();
                    res(...params);
                };

                const reject = (...params) => {
                    script.remove();
                    rej(...params);
                };

                if (process.env.NODE_ENV === "development") {
                    const observer = new MutationObserver((mutations) => {
                        for (const m of mutations) {
                            for (const node of m.addedNodes) {
                                if (node.tagName === "META" && node.httpEquiv === "Content-Security-Policy" && node.content.includes("upgrade-insecure-requests")) {
                                    node.remove();
                                }
                            }
                        }
                    });

                    observer.observe(document.head, { childList: true });
                }

                const script = document.createElement("script");
                script.src = "https://form.kp-pay.com/assets/js/custom/kcb/auth/phoneAuth.js";
                script.async = true;

                script.onload = async () => {
                    try {
                        let { publicKey, vaccount } = await api.v1.me.vaccount.generate.post();

                        let payload = UserVaccountAider.makeStartPayload({
                            publicKey: CryptoAES.decrypt(publicKey),
                            trxType: "0",
                            trackId: vaccount.trackId,
                            identity: vaccount.sender.birth || undefined,
                            holderName: vaccount.holder,
                            phoneNo: vaccount.sender.phone,
                            userAccountName: vaccount.sender.name,
                            account: vaccount.number,
                            udf1: CryptoAES.encrypt(vaccount.trackId),
                            redirectUrl: "",
                            responseType: "0",

                            responseFunction: async (response) => {
                                if (response?.result?.resultCd !== "0000") {
                                    let message = UserVaccountAider.getErrorMessage({ response });
                                    alert(message);
                                    return reject(new Error(message));
                                }

                                try {
                                    let trackId = response.vact.trackId;
                                    let bankCode = response.vact.withdrawBankCd;
                                    let bankName = UserVaccountAider.getBankName({ bankCode });
                                    let holder = vaccount.sender.name;
                                    let number = response.vact.withdrawAccount;

                                    let result = await api.v1.me.vaccount.validate.post({
                                        trackId,
                                        bankCode,
                                        bankName,
                                        number,
                                        holder,
                                    });

                                    commit("setValue", { vaccount });
                                    resolve(vaccount);
                                } catch (error) {
                                    commit("setValue");
                                    reject(error);
                                }
                            },
                        });

                        KPPayForm.start(payload);
                    } catch (error) {
                        reject(error);
                    }
                };

                document.head.appendChild(script);
            });
        },
    },
};
